/* eslint-disable @typescript-eslint/no-explicit-any */
import React, {
  FunctionComponent,
  useEffect,
  useMemo,
  useRef,
  useState,
} from "react"
import AsyncCreatableSelect from "react-select/async-creatable"
import { iSelectOptionType } from "../../../definitions/interfaces"
import { selectStyle } from "./style"

interface iProps {
  name: string
  loadOptions: (input: string) => Promise<any>
  onCreateOption: (input: string) => Promise<any>
  label?: string
  placeholder?: string
  isMulti?: boolean
  defaultOptions?: Array<any> | boolean
  value?: any
  onChange?: (data: any) => void
}

const AsyncCreatableSelectInput: FunctionComponent<iProps> = ({
  name,
  loadOptions,
  onCreateOption,
  isMulti = false,
  label,
  placeholder,
  defaultOptions = true,
  value,
  onChange,
}) => {
  const [_value, setValue] = useState<any>()
  const valueRef = useRef<any>(value)
  const [isLoading, setLoading] = useState(true)
  const styles = useMemo(() => selectStyle({ isMulti }), [isMulti])
  const _isInitialLoad = useRef<boolean>(true)

  const onLoadOptions = async (input: string) => {
    setLoading(true)
    const result: iSelectOptionType<string>[] = await loadOptions(input)

    if (_isInitialLoad.current) {
      _isInitialLoad.current = false

      if (isMulti) {
        setValue(
          result.filter((x: iSelectOptionType<string>) =>
            (valueRef.current || []).includes(x.value),
          ),
        )
      } else {
        setValue(
          result.filter(
            (x: iSelectOptionType<string>) => x.value === valueRef.current,
          ),
        )
      }
    }
    setLoading(false)
    return result
  }

  useEffect(() => {
    valueRef.current = value
  }, [value])

  // eslint-disable-next-line @typescript-eslint/no-explicit-any
  const handleChange = (data: any) => {
    setValue(data)
    if (!onChange) return
    if (!data) {
      onChange("")
      return
    }

    if (isMulti) {
      onChange(
        (data as iSelectOptionType<string>[]).map(
          (d: iSelectOptionType<string>) => d.value,
        ),
      )
    } else {
      onChange((data as iSelectOptionType<string>).value)
    }
  }

  const handleCreateOption = async (input: string) => {
    const data = await onCreateOption(input)
    if (isMulti) {
      const tmp = [...(_value || []), data]
      onChange && onChange(tmp.map((v) => v.value))
      setValue(tmp)
    } else {
      onChange && onChange(data.value)
      setValue(data)
    }
  }

  return (
    <div className="form-group">
      <label htmlFor={name}>{label}</label>
      <div className="form-control">
        <AsyncCreatableSelect
          styles={styles}
          placeholder={placeholder}
          classNamePrefix="react-select"
          menuPlacement="auto"
          className="select"
          isLoading={isLoading}
          isMulti={isMulti}
          defaultOptions={defaultOptions}
          loadOptions={onLoadOptions}
          onCreateOption={handleCreateOption}
          value={_value}
          onChange={handleChange}
        />
      </div>
    </div>
  )
}

export default AsyncCreatableSelectInput
